import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { NbDialogService } from '@nebular/theme';
import { HttpClient } from "@angular/common/http";
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-attachgroup',
  templateUrl: './edit-attachgroup.component.html',
  styleUrls: ['./edit-attachgroup.component.scss']
})
export class EditAttachgroupComponent implements OnInit {
  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() orgData: PRDAttachItemGroupReq;  //已選資料_來源
  @Input() info: {
    IsLoding:false,
    ORG_Company_ID: number,
    ORG_Store_ID:number,
    USR_AccountInfo_ID: string,
    moType: number;//目前編輯狀態 1.新增 2.編輯 3.複製
    orgType: number ; //來源類型 0/null 附加品項設定 1商品設定檔 2菜單檔 3使用中菜單檔
    GroupNo: string
    ModelNoList:any[]
  };

  @ViewChild('Modal') Modal: TemplateRef<any>
  modalRef = null;  //談窗鉤子

  //編輯附加品項談窗中 資料
  attGroup: PRDAttachItemGroupReq;

  //編輯附加品項談窗中 附加品項table列表
  attachItemSource: LocalDataSource = new LocalDataSource();

  //---------------選項列表-------->--------------//
  //稅率列表
  // TaxRateList = []
  // TaxTypeList = [
  //   {value:1,content:"免稅"},
  //   {value:2,content:"應稅"},
  //   {value:3,content:"零稅"}]

  GroupList : selectData[]

  storeSelectList = []

  //-------<--------選項列表----------------------//



  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    this.getStoreList();
  }

  ngAfterViewInit() {
    this.onOpen(this.info, this.orgData)
    
  }

  onOpen(info, data) {
    console.log('mydata', data)
    if(!this.info.orgType)
      this.getGroupList()

    if (info)
      this.info = info



    this.attGroup = new PRDAttachItemGroupReq();
   
    if (this.info.moType == 1) {

      //新增群組資料       
     
      this.attGroup.AttachItemKind = "1";
      this.attGroup.IsRequired = "1";
      this.attGroup.IsConsistent = "0";
      this.attGroup.PRDAttachItemList = []
      this.attGroup.ModelNoList = Array.isArray(this.info.ModelNoList) ? this.info.ModelNoList : []
    }


    else if (this.info.moType == 2 || this.info.moType == 4 ) {
      

      if (data.PRDMenuAttachItemGroupNo) {
        this.orgData = data
        this.attGroup = _.cloneDeep(this.orgData)
        this.attGroup.ModelNoList = this.attGroup.ModelList ? this.attGroup.ModelList.map(x=>x.PRDMenuAttachItemModelNo) : []
        // this.sortItemAndReload();
      }
      else {
        this.GetGroupDetail(this.info.GroupNo, (rep) => {
          this.orgData = rep
          this.attGroup = _.cloneDeep(this.orgData)
          this.attGroup.ModelNoList = this.attGroup.ModelList ? this.attGroup.ModelList.map(x=>x.PRDMenuAttachItemModelNo) : []
          // this.sortItemAndReload();
        })
      }


    }
    else if (this.info.moType == 3) {

      if (data.PRDMenuAttachItemGroupNo) {
        this.orgData = data
        this.attGroup = _.cloneDeep(this.orgData)
        this.attGroup.ModelNoList = this.attGroup.ModelList ? this.attGroup.ModelList.map(x=>x.PRDMenuAttachItemModelNo) : []
        this.attGroup.PRDMenuAttachItemGroupNo = null;
        
        // this.sortItemAndReload();
      }
      else {
        this.GetGroupDetail(this.info.GroupNo, (rep) => {
          this.orgData = rep
          this.attGroup = _.cloneDeep(this.orgData)
          this.attGroup.ModelNoList = this.attGroup.ModelList ? this.attGroup.ModelList.map(x=>x.PRDMenuAttachItemModelNo) : []
          this.attGroup.PRDMenuAttachItemGroupNo = null;
          // this.sortItemAndReload();
        })
      }

    }
    

    this.modalRef = this.dialogService.open(this.Modal, {})
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });



  }

  initData(data) {
    this.orgData = data

    if (this.info.moType == 2) {

      this.attGroup = _.cloneDeep(this.orgData)
      // this.sortItemAndReload();
    }
    else if (this.info.moType == 3) {

      this.attGroup = _.cloneDeep(this.orgData)
      this.attGroup.PRDMenuAttachItemGroupNo = null;
      // this.sortItemAndReload();
    }
  }


  //取得門市清單
  getStoreList() {//取得門市清單 USP_YOPOSWebGetStoreList
    this.http.post<any>('api/ORGStore/StoreList', {
      ORG_Company_ID: this.info.ORG_Company_ID,
      ORG_Store_ID: this.info.ORG_Store_ID,
    }).subscribe({
      next: data => {

        this.storeSelectList = [];
        data.LIST.forEach(element => {
          //門市共用下拉選單
          var selectItem = new selectData();
          selectItem.value = element.ORG_Store_ID;
          selectItem.content = element.StoreName;
          this.storeSelectList.push(selectItem);
        });
      
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });

  }


  onSave() {

    if(this.attGroup.AttachItemKind == "2" ){
      if ( this.attGroup.IsRequired == "1" && (this.attGroup.SelectMinLimit < 1 || this.attGroup.SelectMinLimit == undefined)) {
        alert("群組為必填時，最少可選數量需大於0!")
        return
      }

      if(  this.attGroup.SelectUpLimit != null &&
      this.attGroup.SelectUpLimit < this.attGroup.SelectMinLimit){
        alert("群組的最少可選數量不可大於最大可選數量!")
        return
      }

      //當品項最小可選數量是1時，群組為必填，跳警告
      let list = this.attGroup.PRDAttachItemList
      if (list && list.length) {
        let obj = list.find(x => x.MinSelectTimes > 0)
        if (obj && this.attGroup.IsRequired == "2") {
          alert("有選項的最少可選數量>0，群組需設為必填!")
          return
        }

        let obj2 = list.find(x => x.MaxSelectTimes !=null && x.MinSelectTimes > x.MaxSelectTimes)
        if (obj2) {
          alert("選項的最少可選數量不可大於最大可選數量!")
          return
        }

        let omin = 0
        let omax = 0
        let nullmax = 0 
        list.forEach(x => {
          if(x.MinSelectTimes)
            omin +=   x.MinSelectTimes       

          if(x.MaxSelectTimes)
            omax +=  x.MaxSelectTimes 
          else (x.MaxSelectTimes!=0)
            nullmax += 1
        })

        if (this.attGroup.SelectMinLimit!= null  && omin > this.attGroup.SelectMinLimit   ) {
          alert("群組最少可選數量，不可小於選項的最少可選數量加總!")
          return
        }

        //當選項中沒有無限數量時
        if (nullmax ==0  && this.attGroup.SelectUpLimit!= null  && omax != this.attGroup.SelectUpLimit   ) {
          alert("群組最多可選數量，不符合選項的最多可選數量加總!")
          return
        }
               
      }

     


    }else{

      let list = this.attGroup.PRDAttachItemList
      if (list && list.length) {
        let objL = this.attGroup.PRDAttachItemList.filter(x=>x.IsDefault)
        if (objL && objL.length>1) {
          alert("單選時，只能有一個預設選項!")
          return
        }
      }
    }


    this.attGroup.ORG_Company_ID = this.info.ORG_Company_ID;
    this.attGroup.USR_AccountInfo_ID = this.info.USR_AccountInfo_ID;

    this.emitList.emit(this.attGroup)
    // this.modalRef.close(() => {  })
  }


  //取得群組資料 API
  GetGroupDetail(no, fun) {
    if(this.info.orgType == 3) {
      this.GetGroupDetailAPI_useing(no, fun)
    }
    else{ 
      this.GetGroupDetailAPI_setting(no, fun)
    }

  }

    

  //取得附加品項詳資 API  設定檔
  GetGroupDetailAPI_setting(no, fun){
    this.http
    .get<any>(
      "api/AttachItemSetting/GetAttachItemDetail/" + no
    )
    .subscribe({
      next: (data) => {
        if (fun)
        fun(data)
      },
      error: (error) => {
        console.error("取得附加品項API error!", error);
      },
    });
  }

  //取得附加品項詳資 API  使用中檔
  GetGroupDetailAPI_useing(no, fun){
    this.http
    .get<any>(
      "api/UsingMenu/GetPRDAttachItemGroupDetail/" + no
    )
    .subscribe({
      next: (data) => {
        if (data.LIST) {
          if (fun)
            fun(data.LIST[0])
        }
      },
      error: (error) => {
        console.error("取得附加品項API error!", error);
      },
    });
  }


  //取得分類列表
  getGroupList() {
    let par = {
      ORG_Company_ID: this.info.ORG_Company_ID,
      IsDelete: false,
    }
  

    this.http.post<any>('api/AttachItemSetting/GetAttachItemGroup', par).subscribe({
      next: data => {

        this.GroupList = [];
        data.LIST.forEach(element => {
          let item = new selectData();
          item.value = element.PRDMenuAttachItemModelNo;
          item.content = element.GroupName;
          this.GroupList.push(item);
        });


      },
      error: error => {
        //this.errorMessage = error.message;
        console.error('There was an error!', error);
      }
    });

  }


  //-------------------------附加品項細項--------------------------


  //附加品項細項 單選
  selectDefault(obj,field){
    let x = obj[field]

    if(this.attGroup.AttachItemKind == '1'){
      this.attGroup.PRDAttachItemList.forEach(x=>{
        x[field] = false      
      }) 
    }       
    
    obj[field] = !x
  }

  


  //附加品項細項 刪除
  onDel(index: number) {
    this.attGroup.PRDAttachItemList.splice(index, 1);
    // this.sortItemAndReload();
  }

  //附加品項細項 重新計算順序 並且重載列表資料
  sortItemAndReload() {
    if (!this.attGroup.PRDAttachItemList) return
    var i = 1;
    this.attGroup.PRDAttachItemList.forEach(function (data) {
      data.Sorting = i;
      i++
    });
    this.attachItemSource.load(this.attGroup.PRDAttachItemList);
  }



  //附加品項細項 編輯
  @ViewChild('EditAttachMO_Tmp', { static: false }) EditAttachMO_Tmp
  EditAttachMO = {
    info: {
      moType: null, //1:新增 2:編輯
      selectType: null,
      isRequired: null,
      CreateStore:null,
    },
    isShow: false,
    data: null,
    onOpen: (type, data) => {
      let my = this.EditAttachMO
      if (data)
        my.data = data

      my.info = {
        moType: type,
        selectType: this.attGroup.AttachItemKind,
        isRequired: this.attGroup.IsRequired,
        CreateStore:null
      }
      //this.EditAttachMO_Tmp.onOpen(my.info,data)
      my.isShow = true
    },
    onSave: (data) => {
      let my = this.EditAttachMO

      if (my.info.moType == 1) {

        if (!this.attGroup.PRDAttachItemList ) 
          this.attGroup.PRDAttachItemList = [];
          data.CreateStore =  this.info.ORG_Store_ID

        this.attGroup.PRDAttachItemList.push(data)
        this.attGroup.PRDAttachItemList.forEach((item, index) => {
          item.Sorting = index + 1;
        });
      }
      else {
        _.assign(my.data, data)
      }
    },
    onClose(v) {
      this.isShow = false
    },
    onDelete:(data, isDelete) => {
      let str = isDelete ? '停用' : '啟用'
      if (window.confirm(`確認${str}?`)) {
        data.IsDelete = isDelete ? true : false;
        this.EditAttachMO.updateisdelete(isDelete);
      } else {
        data.confirm.reject();
      }
    },
    updateisdelete:(isDelete) => {
      this.http.post<any>('api/UsingMenu/UpdateAttachStatus', {
        USR_AccountInfo_ID: this.info.USR_AccountInfo_ID, //建立者,
        ORG_Company_ID: this.info.ORG_Company_ID,
        ORG_Store_ID: this.info.ORG_Store_ID,
        IsDelete: isDelete
      }).subscribe({
        next: data => {
          this.onOpen(this.info, this.orgData)
        },
        error: error => {
          console.error('There was an error!', error);
        }
      });

    }
  }


  //附加品項細項  選擇已存在的商品
  @ViewChild('ProductListMO_Tmp', { static: false }) ProductListMO_Tmp
  ProductListMO = {
    info: {
    },
    isShow: false,
    data: null,
    other: {
      attList: [],
    },
    onOpen: () => {
      let my = this.ProductListMO
      my.info = {
      }

      if(this.attGroup.PRDAttachItemList){
        my.other.attList = this.attGroup.PRDAttachItemList.filter(x => !x.PRDProductNo)
        my.data = this.attGroup.PRDAttachItemList.filter(x => x.PRDProductNo)
        my.data.forEach(x=>{
           x.Name  = x.ItemName
           x.No = x.PRDProductNo 
           Name: x.ProductName
        })
      }else{
        my.data = []
        my.other.attList = []
      }
      my.isShow = true
      //this.ProductListMO_Tmp.onOpen(my.info,pdList)
    },
    onSave: (data) => {
      let my = this.ProductListMO

      let list = []
      data.forEach(p => {
        list.push(p)
      })

      list.forEach(x => {
        if (x.SaleCash == null)
          x.SaleCash = 0
        if (x.Quantity == null)
          x.Quantity = 1
        if(this.attGroup.AttachItemKind == '2'){
          if (x.MaxSelectTimes == null)
            x.MaxSelectTimes = 1
            if (x.MinSelectTimes == null)
            x.MinSelectTimes = 0
        }
        x.PRDProductNo = x.No
        x.ItemName = x.Name

        let p = my.data.find(p=>p.PRDProductNo == x.No)
        if(p)
          x.Sorting = p.Sorting
      })

      if(!this.attGroup.PRDAttachItemList)
        this.attGroup.PRDAttachItemList = []

      let result = _.concat(my.other.attList, list)
      // this.attGroup.PRDAttachItemList = _.orderBy(result,['Sorting'],['asc'])
      
      result.forEach((item, index) => {
        item.Sorting = index + 1;
      });
      
      this.attGroup.PRDAttachItemList = result;
      

    },
    onClose(v) {
      this.isShow = false
    }
  }



  //附加品項細項   選擇已存在的附加品項
  @ViewChild('AttachListMO_Tmp', { static: false }) AttachListMO_Tmp
  AttachListMO = {
    info: {
      ORG_Company_ID: null,
    },
    isShow: false,
    other: {
      pdList: []
    },
    data: null,
    onOpen: () => {
      let my = this.AttachListMO
      my.info = {
        ORG_Company_ID: this.info.ORG_Company_ID
      }

      if(this.attGroup.PRDAttachItemList){
        my.data = this.attGroup.PRDAttachItemList.filter(x => !x.PRDProductNo)
        my.other.pdList = this.attGroup.PRDAttachItemList.filter(x => x.PRDProductNo)
      }else{
        my.data = []
        my.other.pdList = []
      }

      my.isShow = true
      //this.AttachListMO_Tmp.onOpen(my.info,attList)
    },
    onSave: (data) => {
      let my = this.AttachListMO      

      console.log('加入附加品項', data)
      data.forEach(x => {
        
        if (x.SaleCash == null)
          x.SaleCash = 0
        if (x.Quantity == null)
          x.Quantity = 1
        if(this.attGroup.AttachItemKind == '2'){
          if (x.MaxSelectTimes == null)
          x.MaxSelectTimes = 1
          if (x.MinSelectTimes == null)
          x.MinSelectTimes = 0
        }


        let p = my.data.find(p=>p.PRDAttachItemNo == x.PRDAttachItemNo)
        if(p)
          x.Sorting = p.Sorting
         
      })

      if(!this.attGroup.PRDAttachItemList)
        this.attGroup.PRDAttachItemList = []

      let result = _.concat(data, my.other.pdList)
      this.attGroup.PRDAttachItemList = _.orderBy(result,['Sorting'],['asc'])


    },
    onClose(v) {
      this.isShow = false
    }

  }


  //附加品項細項  查看商品詳情
  @ViewChild('ProductEditMo_Tmp', { static: false }) ProductEditMo_Tmp
  ProductEditMo = {
    info: {
      moType: 4, //1:新增 2:編輯
      pdShowType:2,
      ORG_Store_ID:null,
      PRDProductNo:null,
      orgType: null,
      groupList: [],
    },
    isShow: false,
    data: {
      PRDProductNo: null,
    },
    onOpen: (type, PRDProductNo) => {
      let my = this.ProductEditMo
      my.info.moType= 4 ;
      my.info.orgType= this.info.orgType != 3 ? 1 : 3 ;
      my.info.PRDProductNo = PRDProductNo
      my.info.ORG_Store_ID = this.info.ORG_Store_ID
      my.info.pdShowType = 2

      let groupList = []      
      if(my.info.orgType == 1 ){

        my.getDataAPI_Setting((data) => {

          my.getGroupListAPI_Setting((data) => {
            //共用下拉選單
            data.forEach(element => {
              let item = new selectData();
              item.value = element.PRDGroupNo;
              item.content = element.GroupName;
              groupList.push(item);
            });               
          })

        
          my.info.groupList= groupList ;

          my.data = data
          my.isShow = true
        })

      }
      else{
        
        my.data = null
        my.isShow = true
      }

    },
    onClose: (v) => {
      let my = this.ProductEditMo
      my.isShow = false
    },
    getDataAPI_Setting: (fun) => {
      let my = this.ProductEditMo
      let par = {
        PRDProductNo: my.info.PRDProductNo

      }

      this.http.post<any>('api/ProductSetting/GetProductDetail', par).subscribe({
        next: data => {
          if (fun)
            fun(data)
        },
        error: error => {
          console.error('There was an error!', error);
        }
      });

    },
    getGroupListAPI_Setting: (fun) => {
      let my = this.ProductEditMo
     
      let par = {
        ORG_Company_ID: this.info.ORG_Company_ID.toString(),
        IsDelete: false,
      }
      this.http.post<any>('api/ProductSetting/GetProductGroup', par).subscribe({
        next: data => {  
          fun(data.LIST)
        },
        error: error => {
        }
      });


    },
  
  }

//商品 編輯
@ViewChild('EditAttAKAMoDOM', { static: false }) EditAttAKAMoDOM
EditAttAKAMoRef = null;
EditAttAKAMo = {
  info: {
    IsLoding: false,
    moType: null, //1:新增 2:編輯
    PRDAttachItemNo: null,
    storeId: null,
    ProductName: null,
  },
  data: {
    selectStore: null,
    List: [{
      TypeName: "POS顯示",
      Type: 1,
      Name: ""
    }, {
      TypeName: "訂單明細",
      Type: 2,
      Name: ""
    }, {
      TypeName: "廚房聯",
      Type: 3,
      Name: ""
    }, {
      TypeName: "顧客聯",
      Type: 4,
      Name: ""
    }, {
      TypeName: "標籤",
      Type: 5,
      Name: ""
    }, {
      TypeName: "關帳小結",
      Type: 6,
      Name: ""
    }
      // ,{
      //   TypeName:"Ubereat",
      //   Type:7,
      //   Name:""
      // },{
      //   TypeName:"FoodPanda",
      //   Type:8,
      //   Name:""
      // },{
      //   TypeName:"線上點餐",
      //   Type:9,
      //   Name:""
      // }
    ]
  },
  onOpen: (type, data) => {
    let my = this.EditAttAKAMo
    my.info.moType = type
    my.info.PRDAttachItemNo = data.PRDAttachItemNo
    my.info.ProductName = data.AttachItemName
    my.info.storeId  = data.CreateStore

    my.getData(() => {
      this.EditAttAKAMoRef = this.dialogService.open(this.EditAttAKAMoDOM, {})
    })

    my.data.selectStore = this.storeSelectList[0].value
  },
  onSave: (data) => {
    let my = this.EditAttAKAMo
    my.info.IsLoding = true
    let req = {
      PRDAttachItemNo: my.info.PRDAttachItemNo,
      ORG_Store_ID: my.info.storeId == 0 ? my.data.selectStore : my.info.storeId,
      USR_AccountInfo_ID: this.info.USR_AccountInfo_ID, //建立者,
      LIST: my.data.List

    }
    this.http.post<any>('api/AttachItemSetting/ModifyAttachAKA', req).subscribe({
      next: data => {
        console.log(data);
        if (data.RESULT != null && data.RESULT != '') {
          alert(data.RESULT);
        } else {
          this.EditAttAKAMoRef.close()
        }
        my.info.IsLoding = false
      },
      error: error => {
        console.error('There was an error!', error);
        my.info.IsLoding = false
      }
    })

  },

  getData: (fun) => {
    let my = this.EditAttAKAMo
    let par = {
      PRDAttachItemNo: my.info.PRDAttachItemNo,
      ORG_Store_ID: my.info.storeId == 0 ? my.data.selectStore : my.info.storeId,
    }

    this.http.post<any>('api/AttachItemSetting/GetAttachAKAList', par).subscribe({
      next: data => {
        if (!data.LIST)
          data.LIST = []

        my.data.List.forEach(x => x.Name = "")

        data.LIST.forEach(x => {
          let obj = my.data.List.find(y => y.Type == x.Type);
          obj.Name = x.Name
        })

        if (fun)
          fun()
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });
  },
}


//商品 編輯
@ViewChild('EditLanguageMoDOM', { static: false }) EditLanguageMoDOM
EditLanguageMoRef = null;
EditLanguageMo = {
  info: {
    IsLoding: false,
    moType: null, //1:新增 2:編輯
    PRDAttachItemNo: null,
    storeId: null,
    ProductName: null,
  },
  data: {
    selectStore: null,
    IsAITranslate: false,
    List: [] as LanguageListDTO[]
  },
  onOpen: (data) => {
    console.log(data);    
    let my = this.EditLanguageMo
    my.info.PRDAttachItemNo = data.PRDAttachItemNo
    my.info.ProductName = data.AttachItemName
    my.info.storeId  = data.CreateStore

    my.getData(() => {
      this.EditLanguageMoRef = this.dialogService.open(this.EditLanguageMoDOM, {})
    })

    my.data.selectStore = this.storeSelectList[0].value


  },
  onSave: (data) => {
    let my = this.EditLanguageMo
    my.info.IsLoding = true
    let req = {
      PRDAttachItemNo: my.info.PRDAttachItemNo,
      ORG_Store_ID: my.info.storeId == 0 ? my.data.selectStore : my.info.storeId,
      USR_AccountInfo_ID: this.info.USR_AccountInfo_ID, //建立者,
      LIST: my.data.List

    }
    this.http.post<any>('api/AttachItemSetting/ModifyAttachItemLanguage', req).subscribe({
      next: data => {
        console.log(data);
        if (data.RESULT != null && data.RESULT != '') {
          alert(data.RESULT);
        } else {
          this.EditLanguageMoRef.close()
        }
        my.info.IsLoding = false
      },
      error: error => {
        console.error('There was an error!', error);
        my.info.IsLoding = false
      }
    })

  },

  getData: (fun) => {
    let my = this.EditLanguageMo
    let par = {
      ORG_Company_ID: this.info.ORG_Company_ID,
      ORG_Store_ID: this.info.ORG_Store_ID,
      PRDAttachItemNo: my.info.PRDAttachItemNo
    }

    this.http.post<any>('api/AttachItemSetting/GetAttachItemLanguageList', par).subscribe({
      next: data => {
        if (data.LIST) {
          // 過濾掉已停用的語言
          my.data.List = data.LIST.filter(x => !x.IsDelete);
        }

        my.data.IsAITranslate = !!data.IsAITranslate;
        if (fun) fun();
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });
  },
  textTranslate: (item) => {
    let my = this.EditLanguageMo; 
    let targetLanguage = item.LanguageName;
    let nameSource = item.Content;
    let ProductName = my.info.ProductName;
    let par = {
      Texts:[ProductName],
      ToLanguages:[targetLanguage],
      FromLanguage: "zh-Hant"
    }
    this.http.post<any>('api/ProductSetting/TextTranslation', par).subscribe({
      next: data => {
        if (data.IsSuccess) {
          console.log("成功",data)
          item.Name = data.Result[0];
          item.Contant = data.Result[1];
        }
      }
    });
  },
  translateAll: (item) => {
    let my = this.EditLanguageMo;
    let ProductName = my.info.ProductName;
    let tolanguage=this.EditLanguageMo.data.List.map(x => x.LanguageName);
    let par = {
      Texts: [ProductName],
      ToLanguages:tolanguage,
      FromLanguage: "zh-Hant"
    };
    this.http.post<any>('api/ProductSetting/TextTranslation', par).subscribe({
      next: data => {
        if (data.IsSuccess) {
          console.log("成功",data)
          data.Result.forEach((translatedText: string, index: number) => {
          my.data.List[index].Name = translatedText;
          });
        }
      }
    });
  }




}


}










class PRDAttachItemGroupReq {
  ModelNoList:string[];

  ModelList:any;
  PRDMenuAttachItemGroupNo: string;       //附加品項群組編號
  ORG_Company_ID: number;                 //公司ID
  GroupName: string;                      //附加品項群組名稱
  AttachItemKind: string;                 //群組類型:1:單選 2:複選
  IsRequired: string;                     //是否必填:1:必填 2:非必填
  IsConsistent:string;                    //是否規則一致:1:是 2:否
  SelectUpLimit: number;                  //最多可選
  SelectMinLimit: number;                 //最少可選
  Sorting?: number;                       //IsDelete
  IsNoDisplayQuantity: Boolean;           //出單不顯示數量
  PRDAttachItemList: PRDAttachItemReq[];  //附加品項群組
  IsSumSubtotalQty: string;               //計入小計數量

  IsDelete: boolean;                      //IsDelete
  USR_AccountInfo_ID: string;             //建立者
}
export class PRDAttachItemReq {
  PRDProductGroupNo: string               //商品群組編號
  PRDAttachItemNo: string;                //附加品項編號
  PRDProductNo: string;                   //商品編號
  Name: string                            //商品名稱;
  TaxRate: number;
  TaxType: number;
  Note: string;
  Quantity: number;                       //數量
  Cash: number;                           //金額

  MaxSelectTimes: number;                 //最多可選
  MinSelectTimes: number;                 //最少可選
  SaleCash: number;                       //販售金額
  IsSell: boolean;                        //是否販售
  IsDefault:boolean;                      //預設使用
  IsNoDisplayQuantity: Boolean;           //出單不顯示數量
  Sorting: number;                        //排序
  IsSumSubtotalQty: string;               //計入小計數量
}
class selectData {
  value: number;
  content: string;

}

interface LanguageListDTO {
  SYS_Language_ID: number;
  Name: string;
  IsDelete: boolean;
  LanguageName: string;

}
